import { createFeatureSelector, createSelector } from '@ngrx/store';
import { schoolFeatureKey, SchoolState } from './school.reducer';

export const selectSchoolState = createFeatureSelector<SchoolState>(schoolFeatureKey);

export const selectAllSchools = createSelector(selectSchoolState, (state) => state?.schools ?? []);

export const selectSchoolLoading = createSelector(selectSchoolState, (state) => state?.loading ?? false);

export const selectSchoolError = createSelector(selectSchoolState, (state) => state?.error ?? null);

export const selectSelectedSchoolId = createSelector(
  selectSchoolState,
  (state) => state?.selectedSchoolId ?? null
);

export const selectSelectedSchool = createSelector(
  selectAllSchools,
  selectSelectedSchoolId,
  (schools, selectedSchoolId) => schools.find((school) => school.id === selectedSchoolId) ?? null
);
